
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/sustainability/repair",
      function () {
        return require("private-next-pages/sustainability/repair/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/sustainability/repair"])
      });
    }
  